import React, { useRef } from 'react';

import { Button } from '../';

/**
 * Code below is modified from https://codepen.io/coopergoeke/pen/abZqEbK
 */

// The larger the number, the slower the animation
let maxMoveLoopCount = 110
let moveLoopCount = 0

const flipCoin = (coin, button, callback) => {
  moveLoopCount = 0
  flipCoinLoop(coin, button, callback)
}

const resetCoin = (coin, button, callback) => {
  coin.style.setProperty('--coin-x-multiplier', 0)
  coin.style.setProperty('--coin-scale-multiplier', 0)
  coin.style.setProperty('--coin-rotation-multiplier', 0)
  coin.style.setProperty('--shine-opacity-multiplier', 0.4)
  coin.style.setProperty('--shine-bg-multiplier', '50%')
  coin.style.setProperty('opacity', 1)
  // Delay to give the reset animation some time before you can click again
  setTimeout(() => {
    button.clicked = false
  }, 200)
}

const flipCoinLoop = (coin, button, callback) => {
  moveLoopCount++
  let percentageCompleted = moveLoopCount / maxMoveLoopCount;
  coin.angle = -coin.maxFlipAngle * Math.pow((percentageCompleted - 1), 2) + coin.maxFlipAngle
  
  // Calculate the scale and position of the coin moving through the air
  coin.style.setProperty('--coin-y-multiplier', -18 * Math.pow(percentageCompleted * 2.5 - 1, 4) + 18)
  coin.style.setProperty('--coin-x-multiplier', percentageCompleted)
  coin.style.setProperty('--coin-scale-multiplier', percentageCompleted * 0.5)
  coin.style.setProperty('--coin-rotation-multiplier', percentageCompleted * coin.sideRotationCount)

  // Calculate the scale and position values for the different coin faces
  // The math uses sin/cos wave functions to similate the circular motion of 3D spin
  coin.style.setProperty('--front-scale-multiplier', Math.max(Math.cos(coin.angle), 0))
  coin.style.setProperty('--front-y-multiplier', Math.sin(coin.angle))

  coin.style.setProperty('--middle-scale-multiplier', Math.abs(Math.cos(coin.angle), 0))
  coin.style.setProperty('--middle-y-multiplier', Math.cos((coin.angle + Math.PI / 2) % Math.PI))

  coin.style.setProperty('--back-scale-multiplier', Math.max(Math.cos(coin.angle - Math.PI), 0))
  coin.style.setProperty('--back-y-multiplier', Math.sin(coin.angle - Math.PI))

  coin.style.setProperty('--shine-opacity-multiplier', 4 * Math.sin((coin.angle + Math.PI / 2) % Math.PI) - 3.2)
  coin.style.setProperty('--shine-bg-multiplier', -100 * (Math.cos((coin.angle + Math.PI / 2) % Math.PI) - 0.5) + '%')

  // Repeat animation loop
  if (moveLoopCount < maxMoveLoopCount) {
    // if (moveLoopCount === maxMoveLoopCount - 6) button.classList.add('shrink-landing')
    window.requestAnimationFrame(() => flipCoinLoop(coin, button, callback))
  } else {
    button.classList.add('coin-landed')
    coin.style.setProperty('opacity', 0)
    callback();
    setTimeout(() => {
      button.classList.remove('clicked', 'shrink-landing', 'coin-landed')
      setTimeout(() => {
        resetCoin(coin, button, callback)
      }, 300)
    }, 1500)
  }
}


export const CoinFlip = ({buttonText, onFlipFinish}) => {

  const coinRef = useRef();
  const audioRef = useRef();

  const handleClick = (e) => {
    const button = e.target;
    const coin = coinRef.current;
    
    if (button.clicked) return

    button.classList.add('clicked')
    audioRef.current.play();

    // Wait to start flipping the coin because of the button tilt animation
    setTimeout(() => {
      // Randomize the flipping speeds just for fun
      coin.sideRotationCount = Math.floor(Math.random() * 5) * 90
      coin.maxFlipAngle = (Math.floor(Math.random() * 4) + 3) * Math.PI
      button.clicked = true
      flipCoin(coin, button, onFlipFinish)
    }, 50)
  }
  
  return (
    <>
      <div className="coin-container" style={{flexGrow: 1, height: 1, position: 'relative', }}>

        <div>
          <audio ref={audioRef} src={`${process.env.PUBLIC_URL}/assets/audio/coin.wav`} />
        </div>
        
        <div className="coin-wrapper">
          <div className="coin" ref={coinRef} >
            <div className="coin__middle"></div>
            <div className="coin__back"></div>
            <div className="coin__front"></div>
          </div>
        </div>

      </div> 

      <Button onClick={handleClick} >
        {buttonText}
      </Button>

    </>
  )
}